{
  "title": "Guardian of Nature",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "4th-level transmutation",
  "level": 4,
  "castingTime": "1 bonus action",
  "range": "Self",
  "components": "V",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "A nature spirit answers your call and transforms you into a powerful guardian. The transformation lasts until the spell ends. You choose one of the following forms to assume: Primal Beast or Great Tree.",
    "Primal Beast. Bestial fur covers your body, your facial features become feral, and you gain the following benefits:",
    "Your walking speed increases by 10 feet.",
    "You gain darkvision with a range of 120 feet.",
    "You make Strength-based attack rolls with advantage.",
    "Your melee weapon attacks deal an extra 1d6 force damage on a hit.",
    "Great Tree. Your skin appears barky, leaves sprout from your hair, and you gain the following benefits:",
    "You gain 10 temporary hit points.",
    "You make Constitution saving throws with advantage.",
    "You make Dexterity and Wisdom-based attack rolls with advantage.",
    "While you are on the ground, the ground within 15 feet of you is difficult terrain for your enemies."
  ],
  "spellLists": ["druid", "ranger"]
}
